import React from 'react';

function LeagueFilters({ filters, onFiltersChange }) {
    const handleFilterChange = (filterType, value) => {
        const newFilters = { ...filters, [filterType]: value };
        onFiltersChange(newFilters);
    };

    const clearFilters = () => {
        onFiltersChange({
            leagueType: 'PUBLIC',
            status: 'OPEN',
            searchTerm: ''
        });
    };

    return (
        <div style={{
            backgroundColor: '#4a5568',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '20px',
            border: '2px solid #2d3748'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '15px'
            }}>
                <h3 style={{
                    color: '#f7fafc',
                    margin: 0,
                    fontSize: '16px'
                }}>
                    Filter Leagues
                </h3>
                <button
                    onClick={clearFilters}
                    style={{
                        backgroundColor: 'transparent',
                        color: '#4299e1',
                        border: '1px solid #4299e1',
                        borderRadius: '6px',
                        padding: '4px 12px',
                        fontSize: '12px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#4299e1';
                        e.target.style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.color = '#4299e1';
                    }}
                >
                    Clear Filters
                </button>
            </div>

            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '15px',
                alignItems: 'end'
            }}>
                {/* League Type Filter */}
                <div>
                    <label style={{
                        display: 'block',
                        color: '#a0aec0',
                        fontSize: '14px',
                        marginBottom: '6px',
                        fontWeight: '500'
                    }}>
                        League Type
                    </label>
                    <select
                        value={filters.leagueType}
                        onChange={(e) => handleFilterChange('leagueType', e.target.value)}
                        style={{
                            width: '100%',
                            padding: '8px 12px',
                            backgroundColor: '#2d3748',
                            color: '#f7fafc',
                            border: '2px solid #4a5568',
                            borderRadius: '8px',
                            fontSize: '14px',
                            cursor: 'pointer',
                            transition: 'border-color 0.2s ease'
                        }}
                        onFocus={(e) => {
                            e.target.style.borderColor = '#4299e1';
                        }}
                        onBlur={(e) => {
                            e.target.style.borderColor = '#4a5568';
                        }}
                    >
                        <option value="ALL">All Types</option>
                        <option value="PUBLIC">🌐 Public</option>
                        <option value="PRIVATE">🔒 Private</option>
                    </select>
                </div>

                {/* Status Filter */}
                <div>
                    <label style={{
                        display: 'block',
                        color: '#a0aec0',
                        fontSize: '14px',
                        marginBottom: '6px',
                        fontWeight: '500'
                    }}>
                        Status
                    </label>
                    <select
                        value={filters.status}
                        onChange={(e) => handleFilterChange('status', e.target.value)}
                        style={{
                            width: '100%',
                            padding: '8px 12px',
                            backgroundColor: '#2d3748',
                            color: '#f7fafc',
                            border: '2px solid #4a5568',
                            borderRadius: '8px',
                            fontSize: '14px',
                            cursor: 'pointer',
                            transition: 'border-color 0.2s ease'
                        }}
                        onFocus={(e) => {
                            e.target.style.borderColor = '#4299e1';
                        }}
                        onBlur={(e) => {
                            e.target.style.borderColor = '#4a5568';
                        }}
                    >
                        <option value="ALL">All Status</option>
                        <option value="OPEN">✅ Open</option>
                        <option value="LOCKED">🔒 Locked</option>
                        <option value="COMPLETED">✔️ Completed</option>
                    </select>
                </div>

                {/* Search Filter */}
                <div>
                    <label style={{
                        display: 'block',
                        color: '#a0aec0',
                        fontSize: '14px',
                        marginBottom: '6px',
                        fontWeight: '500'
                    }}>
                        Search League Name
                    </label>
                    <input
                        type="text"
                        placeholder="Search leagues..."
                        value={filters.searchTerm}
                        onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
                        style={{
                            width: '100%',
                            padding: '8px 12px',
                            backgroundColor: '#2d3748',
                            color: '#f7fafc',
                            border: '2px solid #4a5568',
                            borderRadius: '8px',
                            fontSize: '14px',
                            transition: 'border-color 0.2s ease'
                        }}
                        onFocus={(e) => {
                            e.target.style.borderColor = '#4299e1';
                        }}
                        onBlur={(e) => {
                            e.target.style.borderColor = '#4a5568';
                        }}
                    />
                </div>
            </div>

            {/* Active Filters Summary */}
            {(filters.leagueType !== 'PUBLIC' || filters.status !== 'OPEN' || filters.searchTerm) && (
                <div style={{
                    marginTop: '15px',
                    paddingTop: '15px',
                    borderTop: '1px solid #2d3748'
                }}>
                    <div style={{
                        fontSize: '12px',
                        color: '#a0aec0',
                        marginBottom: '6px'
                    }}>
                        Active Filters:
                    </div>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '6px'
                    }}>
                        {filters.leagueType !== 'PUBLIC' && (
                            <span style={{
                                backgroundColor: '#4299e1',
                                color: 'white',
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '11px',
                                fontWeight: 'bold'
                            }}>
                                Type: {filters.leagueType}
                            </span>
                        )}
                        {filters.status !== 'OPEN' && (
                            <span style={{
                                backgroundColor: '#48bb78',
                                color: 'white',
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '11px',
                                fontWeight: 'bold'
                            }}>
                                Status: {filters.status}
                            </span>
                        )}
                        {filters.searchTerm && (
                            <span style={{
                                backgroundColor: '#ed8936',
                                color: 'white',
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '11px',
                                fontWeight: 'bold'
                            }}>
                                Search: "{filters.searchTerm}"
                            </span>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default LeagueFilters;